import { render, staticRenderFns } from "./CategoryTableInactive.vue?vue&type=template&id=1d3c4a91&scoped=true"
import script from "./CategoryTableInactive.vue?vue&type=script&lang=js"
export * from "./CategoryTableInactive.vue?vue&type=script&lang=js"
import style0 from "./CategoryTableInactive.vue?vue&type=style&index=0&id=1d3c4a91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3c4a91",
  null
  
)

export default component.exports